export default element => {
  return {
    width: element.offsetWidth,
    height: element.offsetHeight
  }
}
